import React, { Component } from 'react'
import './projectitem.scss'

import Button from '../Button'
import Tags from '../Tags'
import Tooltip from '../Tooltip'

class ProjectItem extends Component {
	constructor(props) {
		super(props)
		this.state = {
			imgArray: props.imgArray ? props.imgArray : [],
			aTerceros: props.aTerceros ? props.aTerceros : false,
			modelsNum: props.modelsNum ? props.modelsNum : ''
		}
	}

	renderImgSection = () => {
		if (this.state.imgArray.length === 1) {
			return (
				<div className="img-carrier">
					<img src={this.state.imgArray[0]} alt="" />
				</div>
			)
		} else {
			return (
				<div className="img-carrier multiple-img">
					<div className="img-row top">
						<div className="img-col left">
							<img src={this.state.imgArray[0]} alt="" />
						</div>
						<div className="img-col">
							<img src={this.state.imgArray[1]} alt="" />
						</div>
					</div>
					<div className="img-row">
						<div className="img-col left">
							<img src={this.state.imgArray[2]} alt="" />
						</div>
						<div className="img-col">
							<img src={this.state.imgArray[3]} alt="" />
						</div>
					</div>
				</div>
			)
		}
	}

	renderBtnSection = () => {
		if (this.state.aTerceros) {
			return (
				<div className="btn-block">
					<div className="btn-col small-btns">
						<div className="small-btn-row row-33">
							<div className="col-33 btn-col">
								<Button
									classes="ghost medium"
									showIcon={true}
									icon="icon-icon-support"
									onClick={this.props.supportModal}
								></Button>
							</div>
							<div className="col-33 btn-col">
								<Button
									classes="ghost medium"
									showIcon={true}
									icon="icon-icon-edit"
									onClick={this.props.clickEdit}
								></Button>
							</div>
							<div className="col-33 btn-col">
								<Button
									classes="ghost medium"
									showIcon={true}
									icon="icon-icon-download"
									onClick={this.props.downloadModal}
								></Button>
							</div>
							<div className="col-33 btn-col">
								<Button classes="ghost medium" showIcon={true} icon="icon-icon-duplicate"></Button>
							</div>
							<div className="col-33 btn-col">
								<Button
									classes="ghost medium"
									showIcon={true}
									icon="icon-icon-delete"
									onClick={this.props.deleteModal}
								></Button>
							</div>
						</div>
					</div>
					<div className="btn-col">
						<Button
							classes="fill medium content-width"
							showIcon={true}
							icon="icon-icon-airplane"
							onClick={this.props.requestQuoteModal}
						>
							Pedir presupuesto
						</Button>
						<Button classes="ghost medium content-width" showIcon={true} icon="icon-icon-asignar">
							Asignar a tercero
						</Button>
					</div>
				</div>
			)
		} else {
			return (
				<div className="btn-block">
					<div className="btn-col small-btns">
						<div className="small-btn-row row-50">
							<div className="col-50 btn-col">
								<Button
									classes="ghost medium"
									showIcon={true}
									icon="icon-icon-download"
									onClick={this.props.downloadModal}
								></Button>
							</div>
							<div className="col-50 btn-col">
								<Button
									classes="ghost medium"
									showIcon={true}
									icon="icon-icon-edit"
									onClick={this.props.clickEdit}
								></Button>
							</div>
							<div className="col-50 btn-col">
								<Button classes="ghost medium" showIcon={true} icon="icon-icon-duplicate"></Button>
							</div>
							<div className="col-50 btn-col">
								<Button
									classes="ghost medium"
									showIcon={true}
									icon="icon-icon-delete"
									onClick={this.props.deleteModal}
								></Button>
							</div>
						</div>
					</div>
					<div className="btn-col">
						<Button
							classes="fill medium content-width"
							showIcon={true}
							icon="icon-icon-airplane"
							onClick={this.props.requestQuoteModal}
						>
							Pedir presupuesto
						</Button>
						<Button
							classes="ghost medium content-width"
							showIcon={true}
							icon="icon-icon-support"
							onClick={this.props.supportModal}
						>
							Pedir soporte
						</Button>
					</div>
				</div>
			)
		}
	}

	render() {
		let classes = ['vbui--projectitem', this.props.classes, this.props.state].join(' ')
		return (
			<div className={classes}>
				<div className="left-block">
					{this.renderImgSection()}
					<div className="info-container order-1 order-lg-2">
						<div className="tags-container">
							{this.state.modelsNum && <Tags state="active">{this.state.modelsNum} modelos</Tags>}
							{this.state.aTerceros && <Tags>A terceros</Tags>}
						</div>
						<div className="title-container">
							<a href="/">
								<h3 className="title">{this.props.title}</h3>
							</a>
						</div>
						<div className="details-container">
							<div className="details-trigger">
								Detalles del proyecto
								<div className="info-hover">
									<span className="icon-icon-tooltip-2"></span>
									<Tooltip classes="southwest">{this.props.children}</Tooltip>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="right-block">{this.renderBtnSection()}</div>
			</div>
		)
	}
}

export default ProjectItem
